import React, { useState, useEffect} from 'react';
import useAuth from '../../../hooks/useAuth';

const Profile = () => {
    const [loggedInUser, setLoggedInUser] = useState({});
    const {user} = useAuth();
    const email = user.email;

    useEffect(() => {
        fetch(`https://auto-car-shop.herokuapp.com/users/${email}`)
            .then(res => res.json())
            .then(data => {
                setLoggedInUser(data[0]);
            })
    }, [email])
    
    return (
        <div>
            <div>
                <div className="px-4 py-5 sm:px-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">User Information</h3>
                    <p className="mt-1 max-w-2xl text-sm text-gray-500">Personal details and purchase history</p>
                </div>
            </div>
            <div>
                <dl>
                    <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">Full name</dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{loggedInUser.displayName}</dd>
                    </div>
                    <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">Email address</dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{loggedInUser.email}</dd>
                    </div>
                    {
                        loggedInUser.role === 'Admin' ?
                            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">Role</dt>
                                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{loggedInUser.role}</dd>
                            </div>
                            :
                            <></>
                    }
                    


                </dl>
            </div>
        </div>


    );
};

export default Profile;